import React from "react"
import Slider from "react-slick"

function BannerSlider(props) {
    const {settings, data} = props
    const slideritems = data.map((item, i) => (
        <div key={i}>
            <figure className="image is-2by1" key={item.id} style={{borderRadius:'20px'}}>
                <img
                    src={item.img}
                    alt={item.title}
                    className="lazy-img"/>
            </figure>
        </div>
    ))
    return (
        <div className="columns is-mobile is-gapless" style={{borderRadius:'20px'}}>
            <div className="column is-full">
                <Slider {...settings}>
                    {slideritems}
                </Slider>
            </div>
        </div>
    )
}

export default BannerSlider